import { memo } from "react";
import {
  Alert,
  Box,
  IconButton,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import LoadingComponent from "../components/LoadingComponent";
import TableLoader from "../components/TableLoader";
import SellerActions from "../components/SellerActions";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.jsx";
import { useSellers } from "../hooks/useSellers.jsx";


function MySellers() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const {
    sellers,
    sellersCount,
    loading,
    error,
    filters,
    pagination,
    auxSearcher,
    refetchSellers,
    handleFilterChange,
    handleChangePage,
    handleChangeRowsPerPage,
    setAuxSearcher,
    downloadSellers
  } = useSellers();

  const handleTablePageChange = (event, newPage) => {
    handleChangePage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    handleChangeRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      {loading ? <LoadingComponent /> : null}
      {(error) ? (
        <Alert sx={{ borderRadius: "0px !important" }} severity="error">
          {error}
        </Alert>
      ) : null}
      <Grid item xs={12} className="mg-t-20">
        <h2>Mis Sellers</h2>
      </Grid>
      <SellerActions
        loading={loading}
        sellersCount={sellersCount}
        auxSearcher={auxSearcher}
        setAuxSearcher={setAuxSearcher}
        downloadSellers={downloadSellers}
      />

      <Grid container>
        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <>
              <TableContainer>
                {loading ? (
                  <TableLoader />
                ) : (
                  <>
                    <Table
                      aria-label="tabla de Zonas de despacho"
                      className="fixed-table"
                    >
                      <TableHead sx={{ backgroundColor: "#fff" }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}></TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Nombre
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Rut
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Encargado
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Plan
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Creación
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            KAM
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sellers.map((seller) => (
                          <TableRow
                            key={seller.id}
                            hover
                            sx={{
                              "& > *": { borderBottom: "unset" },
                              backgroundColor: "#fff",
                            }}
                          >
                            <TableCell component="th" scope="row">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/home/company/${seller.company.id}`
                                  )
                                }
                              >
                                <i className="material-icons">add</i>
                              </IconButton>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {seller.company?.social_reason}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {seller.rut}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {`${seller.user?.first_name} ${seller.user?.last_name}`}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {seller.company?.plan}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {new Date(seller.user.date_joined).toLocaleDateString()}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {"N/A"}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </>
                )}

                {!loading && sellers.length === 0 && (
                  <Box sx={{ p: 4, textAlign: "center" }}>
                    <Typography color="text.secondary">
                      No se encontraron sellers.
                    </Typography>
                  </Box>
                )}

                <TablePagination
                  rowsPerPageOptions={[20, 40, 60, 80, 100]}
                  component="div"
                  count={sellersCount}
                  rowsPerPage={pagination.rowsPerPage}
                  page={pagination.page - 1}
                  onPageChange={handleTablePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              </TableContainer>
            </>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default memo(MySellers);
